export interface VolumeChannelType {
  value: number;
  temporaryValue: number | null;
  previousValue: number;
}

export type UiChannelType = string | null;

export interface ChannelsType extends Record<string, VolumeChannelType> {}

export interface IVolumeSettings {
  master: VolumeChannelType;
  channels: ChannelsType;
  uiChannel: UiChannelType;
  noVolumeControl?: boolean;
  restored?: boolean;
}

export enum StreamQuality {
  High = 0,
  Medium = 1,
  Low = 2,
  Auto = 'auto',
}

export enum VolumeChannels {
  Studio = 'studio',
  Game = 'game',
}

export interface IStreamState {
  isEnabled: boolean;
  isEnabledBySystem: boolean;
  isVideoPlaying: boolean;
  quality: StreamQuality;
  qualityLimit: number;
  streamLatency: number;
}

export interface ILanguageState {
  current: string;
  handle: string;
  isRTL: boolean;
}

export interface ISettingsInitialState {
  isInFullscreen: boolean;
  isGameVisible: boolean;
  stream: IStreamState;
  volume: IVolumeSettings;
  language: ILanguageState | Record<string, never>;
  showOtherMessages: boolean;
  isAnimationEnabled: boolean;
  isSecondBetBoardToggle: boolean;
  isStudioSoundDisabled?: boolean;
  // TODO: Revisit the code to handle game specific tabs from game level
  settingsTabToHide: string[];
}

export type ChannelVolumeCallbackType = (channelName: string) => VolumeChannelType | null;

export interface ChannelVolumeValueCallbackType {
  (channelName: string): number;
}
